<div class="pv2-price-table-loading" *ngIf="loading">Carregando tabelas...</div>

<div class="pv2-target-switch" *ngIf="!loading && ehProdutoPizzaComTamanhos">
  <div class="pv2-target-switch__choice-group">
    <span class="pv2-target-switch__choice-label">Editar</span>
    <div class="pv2-target-switch__segmented">
      <label class="pv2-target-switch__mode-btn"
             *ngFor="let target of targetsLista"
             [class.is-active]="targetSelecionadoKey === target.key">
        <input type="radio"
               name="produtoTabelaPrecoTarget"
               [value]="target.key"
               [ngModel]="targetSelecionadoKey"
               (ngModelChange)="switchTarget($event)">
        <span class="fa fa-cube"></span>
        <span>{{ target.nome }}</span>
      </label>
    </div>
    <span class="pv2-target-switch__loading" *ngIf="loadingTarget">Carregando...</span>
  </div>
</div>

<div class="pv2-product-price-table"
     *ngIf="!loading && linhas.length"
     [class.is-loading-target]="loadingTarget"
     [class.without-wholesale]="!exibeColunasAtacado">
  <div class="pv2-product-price-table__head">
    <span>Tabela</span>
    <span>Canal</span>
    <span>{{ rotuloPrecoPrincipal }}</span>
    <span>{{ rotuloDesconto }}</span>
    <span *ngIf="exibeColunasAtacado">{{ rotuloPrecoAtacado }}</span>
    <span *ngIf="exibeColunasAtacado">{{ rotuloQuantidadeMinima }}</span>
  </div>

  <div class="pv2-product-price-table__row"
       *ngFor="let linha of linhasExibidas; trackBy: trackByLinha"
       [class.is-configured]="linhaTemDados(linha)"
       [class.is-empty]="!linhaTemDados(linha)"
       [class.is-dirty]="linha.dirty"
       [class.is-invalid-wholesale]="linhaAtacadoInvalida(linha)"
       [class.is-invalid-discount]="linhaDescontoInvalida(linha)"
       [class.is-invalid-price]="linhaPrecoInvalida(linha)"
       [class.is-invalid-wholesale-price]="linhaPrecoAtacadoInvalido(linha)">
    <div class="pv2-product-price-table__name">
      <strong>{{ linha.tabela.nome }}</strong>
      <div class="pv2-product-price-table__badges">
        <span class="pv2-price-configured-badge" *ngIf="linhaTemDados(linha)">Com preço</span>
        <span class="pv2-price-empty-badge" *ngIf="!linhaTemDados(linha)">Sem preço</span>
        <span class="pv2-price-wholesale-badge" *ngIf="linha.tabela.suportaPrecosAtacado">Atacado habilitado</span>
        <span class="pv2-price-dirty-badge" *ngIf="linha.dirty">Alterado</span>
        <span class="pv2-price-error-badge" *ngIf="linhaPrecoInvalida(linha)">Preço inválido</span>
        <span class="pv2-price-error-badge" *ngIf="linhaDescontoInvalida(linha)">Desconto inválido</span>
        <span class="pv2-price-error-badge" *ngIf="linhaPrecoAtacadoInvalido(linha)">Atacado inválido</span>
        <span class="pv2-price-error-badge" *ngIf="linhaAtacadoInvalida(linha)">Qtd. atacado > 1</span>
      </div>
    </div>
    <span>{{ canalLabel(linha.tabela.canal) }}</span>
    <div class="pv2-price-value-cell">
      <kendo-numerictextbox
        [(ngModel)]="linha.item.valor"
        (ngModelChange)="marqueAlterada(linha)"
        [class.is-invalid]="linhaPrecoInvalida(linha)"
        [min]="0"
        [spinners]="false"
        [format]="formatoPrecoTabela"
        [placeholder]="placeholderPrecoTabela"
        [disabled]="!podeEditarPrecos">
      </kendo-numerictextbox>
      <span class="pv2-price-final" *ngIf="linhaTemDesconto(linha)">
        <span class="k-icon k-i-check-circle"></span>
        Final{{ sufixoPrecoTabela }}: {{ obtenhaPrecoFinal(linha) | currency:'BRL':'symbol':'1.2-2' }}
      </span>
      <span class="pv2-price-final-placeholder" *ngIf="!linhaTemDesconto(linha)"></span>
    </div>
    <div class="pv2-price-value-cell">
      <kendo-numerictextbox
        [(ngModel)]="linha.item.desconto"
        (ngModelChange)="marqueAlterada(linha)"
        [class.is-invalid]="linhaDescontoInvalida(linha)"
        [min]="0"
        [spinners]="false"
        [format]="formatoPrecoTabela"
        [placeholder]="placeholderPrecoTabela"
        [disabled]="!podeEditarPrecos">
      </kendo-numerictextbox>
      <span class="pv2-price-discount-percent" *ngIf="linhaTemDesconto(linha); else semDescontoTpl">
        {{ obtenhaPercentualDesconto(linha) | number:'1.1-1' }}%
      </span>
      <ng-template #semDescontoTpl>
        <span class="pv2-price-final-placeholder"></span>
      </ng-template>
    </div>
    <div class="pv2-price-value-cell" *ngIf="exibeColunasAtacado">
      <kendo-numerictextbox
        [(ngModel)]="linha.item.valorAtacado"
        (ngModelChange)="marqueAlterada(linha)"
        [class.is-invalid]="linhaPrecoAtacadoInvalido(linha)"
        [min]="0"
        [spinners]="false"
        [format]="formatoPrecoTabela"
        [placeholder]="placeholderPrecoTabela"
        [disabled]="!podeEditarPrecos || !linha.tabela.suportaPrecosAtacado">
      </kendo-numerictextbox>
      <span class="pv2-price-final-placeholder"></span>
    </div>
    <div class="pv2-price-value-cell" *ngIf="exibeColunasAtacado">
      <input
        [(ngModel)]="linha.item.quantidadeMinimaAtacado"
        (ngModelChange)="marqueAlterada(linha)"
        type="number"
        step="1"
        min="2"
        [disabled]="!podeEditarPrecos || !linha.tabela.suportaPrecosAtacado">
      <span class="pv2-price-final-placeholder"></span>
    </div>
  </div>
</div>

<div class="pv2-price-table-empty" *ngIf="!loading && !linhas.length">
  <div class="pv2-price-table-empty__icon">
    <i class="fas fa-tags"></i>
  </div>
  <div class="pv2-price-table-empty__content">
    <strong>Nenhuma tabela ativa cadastrada.</strong>
    <span>Crie a primeira tabela para liberar precos diferentes por canal, periodo ou atacado.</span>
  </div>
  <a class="pv2-price-table-empty__action" routerLink="/admin/tabelas-precos">Cadastrar primeira tabela</a>
</div>

<div class="pv2-price-table-footer" *ngIf="linhas.length">
  <button type="button"
          class="pv2-primary-btn"
          (click)="salve()"
          [disabled]="!podeSalvarPrecos">
    {{ saving ? 'Salvando...' : salvarPrecosLabel }}
  </button>
</div>
